import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { Helper } from "../../core/util/helper";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { AppHelper } from "../../appHelper"
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import EditCode, { EditCodeProps } from "./EditCode";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { ContextGeneralSettingsApp } from "../generalSettings";
import { Metadata } from "../../core/components/commonApp";
import React from "react";

export default class EditIdentifierGrid extends React.Component<editIdentifierGridProps, editIdentifierGridState> {
    common = new AppHelper();

    constructor(props) {
        super(props);
        this.state = { gridData: [], enableDeleteButton:false };
    }

    private _getGridData = () => {
        const url = "GeneralSettings/GetGridData?context=identifier";

        HTTPService.get<JsonResultClass>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }
    
    private _openCode = (dataItem: data = null) => {
        let entityURL = "Code/GetCode";
        if (dataItem != null) {
            entityURL += "/?KNr=" + dataItem.key;
        }

        HTTPService.chainBatch
            .add<JsonResultClass>(entityURL)
            .add<Metadata>(Helper.getMetaData("code"))
            .promise()
            .then(result => {
                const entity = result[0];
                const metadata = result[1];
                this._initCodeWindow(entity.Data, metadata);
            });
    }

    private _initCodeWindow = (entity: any, metaData: any) => {

        const props: EditCodeProps = {
            dataSources: {}, metadata: metaData as Metadata, entity: entity, isWindow: true, context: {}, title: ""
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, (target) => {
            this._getGridData();
        });

        sheet.show(() => {
            sheet.mountContent(EditCode, props);
        });
    }


    private _deleteIdentifier = (knr: number) => {

        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                const url = "GeneralSettings/DeleteIdentifier?Knr=" + knr;
                HTTPService.get<JsonResultClass>(url)
                    .then(result => {
                        if (result.Code == 0) {
                            if (result.Code === 0) {
                                NotificationHelper.showSuccessMessage(result.Message);
                                this._getGridData()
                            } else {
                                NotificationHelper.showErrorMessage(result.Message);
                            }
                        }
                    });
            }
        });
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: data) => {
        if (type == ToolBarStandardButtonType.NEW) {
            this._openCode();
        }
        else if (type == ToolBarStandardButtonType.EDIT) {
            this._openCode(dataItem);
        }
        else if (type == ToolBarStandardButtonType.DELETE) {
            this._deleteIdentifier(dataItem.key);
        }
    }

    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.enableDeleteButton });

        let grid = (
            <Grid data={this.state.gridData} options={this.props.context.editIdentifierGridOptions} id="identifierGroup"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} onSelectionChanged={this.onSelectedChange} />
        );
        return (grid)
    }

    onSelectedChange = (dataItem: data) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ enableDeleteButton: dataItem.deleteable });
        }
    }

    componentDidMount() {
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <div className="flex-container flex-container__item" style={{ height: "300px" }}>                    
                    {grid}
                </div>
            </div>);

    }
};

interface editIdentifierGridProps {
    context: ContextGeneralSettingsApp;
}

interface editIdentifierGridState {
    gridData: data[];
    enableDeleteButton: boolean;
}

interface data {
    key: number;
    value: string;
    typ: string;
    deleteable: boolean;
}